export default __webpack_public_path__ + "static/media/amex.inline.64483171.svg";